import { 
    apiClient
} from "./APIService";

export const getUserCredits = () => {
    return apiClient.get('/credits', {
        headers: {
            "x-access-token": localStorage.getItem('jwt')
        },
    })
}